export default __webpack_public_path__ + "static/media/btn-zeroback-stop-se_se@2x.4d5b62d2.png";